var map = {
	"./Adlay_Grasses.jpg": 28345,
	"./American-Lobster-Arthropods.jpg": 47126,
	"./Barley-Grasses.jpg": 56825,
	"./Barn-owl-Birds.jpg": 18090,
	"./Basil-Herbs.jpg": 47951,
	"./Blue-whale-Mammals.jpg": 89117,
	"./Bobbit-Worm-Annelids.jpg": 68742,
	"./Bonellia-viridis-Annelids.jpg": 82478,
	"./Bordetella-pertussis.jpg": 62851,
	"./Capitella-capitata-Annelids.jpg": 94128,
	"./Ceratium-pentagonum.jpg": 73589,
	"./Chocolate-vine-Climbers.jpg": 88878,
	"./Cochineal-Arthropods.jpg": 89874,
	"./Coconut-Molluscs.jpg": 14235,
	"./Coconut_tree.jpg": 52900,
	"./Common-Hibiscus-Shrubs.jpg": 4826,
	"./Common-Hibiscus.jpg": 10785,
	"./Common-frog-Amphibians.jpg": 13058,
	"./Common-octopus-Molluscs.jpg": 19082,
	"./Coriander-Herbs.jpg": 38019,
	"./Coscinodiscus-wailesii.jpg": 82991,
	"./Edible-frog-Amphibians.jpg": 84077,
	"./Freshwater-pearl-mussel-Molluscs.jpg": 85853,
	"./Gold-Fish-Fishes.jpg": 79950,
	"./Golden-Eagle-Birds.jpg": 15620,
	"./Green-anole-Reptiles.jpg": 55716,
	"./Hard-clam-Molluscs.jpg": 24951,
	"./Honey-Fungus-Fungi.jpg": 89723,
	"./Hoof-Fungus-Fungi.jpg": 48805,
	"./Kagu-Birds.jpg": 12558,
	"./Klebsiella-pneumoniae.jpg": 34958,
	"./Leopard-gecko-Reptiles.jpg": 6508,
	"./Listeria-monocytogenes.jpg": 89886,
	"./Mealworm-Insects.jpg": 28885,
	"./Monarch-butterfly-Insects.jpg": 36700,
	"./Mountain-laurel-Shrubs.jpg": 89979,
	"./Neem_Tree.jpg": 69739,
	"./Nut-Grass.jpg": 14775,
	"./Oat-Grasses.jpg": 96795,
	"./Oleander-Shrubs.jpg": 96794,
	"./Pacific-purple-sea-urchin-Echinoderms.jpg": 88867,
	"./Papaya.jpg": 22035,
	"./Paper-reed.jpg": 2776,
	"./Paracentrotus-lividus-Echinoderms.jpg": 28406,
	"./Phaeocystis-globosa.jpg": 31869,
	"./Polar-bear-Mammals.jpg": 56902,
	"./Sand-Lizard-Reptiles.jpg": 23902,
	"./Silver-fish-Arthropods.jpg": 54558,
	"./Star-Jasmine-Climbers.jpg": 51917,
	"./Sunflower-sea-star-Echinoderms.jpg": 94664,
	"./Superworm-Insects.jpg": 59287,
	"./Sword-Fish-Fishes.jpg": 22123,
	"./Tiger-Mammals.jpg": 42313,
	"./Trumpet-vine-Climbers.jpg": 85493,
	"./Turkey-tail-Fungi.jpg": 94114,
	"./Turmeric-Herbs.jpg": 83667,
	"./Water-Chestnut.jpg": 45376,
	"./Whale-shark-Fishes.jpg": 88258,
	"./Wood-frog-Amphibians.jpg": 10995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52090;